import { useQuery } from "@tanstack/react-query";
import { UserConverter } from "domain/converter/user.converter";
import { IPaginationInputMeta } from "domain/pagination/pagination-meta";
import { replaceUriParameter, RestEndpoints } from "../../../api/endpoints";
import { ReactQueryConfig } from "../../../config/react-query-config";
import getInstance from "../../../utils/rest";
import { PaginationMetaConverter } from "../../../domain/converter/pagination-meta.converter";
import { IUserResult } from "../../../domain/user/user";
import { IUserResultModel } from "../../../models/user/user.model";
import { SharedQueryKeys } from "../query-keys";

export const getGroupUsers = async (
  erpNumber: string,
  paginationInputMeta?: IPaginationInputMeta,
): Promise<IUserResult> => {
  const url = replaceUriParameter(RestEndpoints.UsersForGroup, "erpNumber", erpNumber);
  const response = await getInstance().get<IUserResultModel>(url, {
    params: {
      ...paginationInputMeta,
    },
  });

  const data: IUserResult = {
    users: response.data.users.map(UserConverter.toDomain),
    meta: response.data.meta ? PaginationMetaConverter.toDomain(response.data.meta) : response.data.meta,
  };

  return data;
};

export const useGetGroupUsers = (
  erpNumber: string,
  paginationInputMeta?: IPaginationInputMeta,
) => {
  return useQuery({
    queryKey: [SharedQueryKeys.GetGroupUsers, erpNumber, paginationInputMeta],
    queryFn: () => getGroupUsers(erpNumber, paginationInputMeta),
    staleTime: ReactQueryConfig.staleTime,
  });
};
